import { Trans } from 'react-i18next'

import { Field, Switch } from '@makyoapp/makyo-ui'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { AccordionItem } from '@/components/Accordion/Accordion'

function BrandingAccordion() {
  const { showBuiltInBranding, showInstallationModal, showCookieConfirmation, handleUpdateShowHideInfos, project } =
    useAppBuilderContext()

  if (!project) return null

  return (
    <AccordionItem itemId='setting-branding' title={<Trans>Show/Hide</Trans>}>
      <Field isVertical className='py-0 flex items-center! flex-row! justify-between! min-h-10!'>
        <label className='w-5/12'>
          <Trans>Built on Makyo</Trans>
        </label>
        <Switch
          checked={showBuiltInBranding}
          onClick={(value) =>
            handleUpdateShowHideInfos(project.id, {
              _WhiteLabeling: value,
              _InstallationModal: showInstallationModal,
              _CookiesNotification: showCookieConfirmation,
            })
          }
        />
      </Field>
      <Field isVertical className='py-0 flex items-center! flex-row! justify-between! min-h-10!'>
        <label className='w-5/12'>
          <Trans>Installation Modal</Trans>
        </label>
        <Switch
          checked={showInstallationModal}
          onClick={(value) =>
            handleUpdateShowHideInfos(project.id, {
              _WhiteLabeling: showBuiltInBranding,
              _InstallationModal: value,
              _CookiesNotification: showCookieConfirmation,
            })
          }
        />
      </Field>
      <Field isVertical className='py-0 flex items-center! flex-row! justify-between! min-h-10!'>
        <label className='w-5/12'>
          <Trans>Cookie Consent</Trans>
        </label>
        <Switch
          checked={showCookieConfirmation}
          onClick={(value) =>
            handleUpdateShowHideInfos(project.id, {
              _WhiteLabeling: showBuiltInBranding,
              _InstallationModal: showInstallationModal,
              _CookiesNotification: value,
            })
          }
        />
      </Field>
    </AccordionItem>
  )
}

export default BrandingAccordion
